import { useEffect, useState } from "react";
import { useLocation, Navigate } from "react-router-dom";
import { api } from "@/lib/api";

export default function SiteGuard({ children }) {
  const [paused, setPaused] = useState(null);
  const loc = useLocation();

  useEffect(() => {
    api.get("/settings").then((r) => setPaused(!!r.data.paused)).catch(() => setPaused(false));
  }, [loc.pathname]);

  if (paused === null) return null;

  const isAdminPath = loc.pathname.startsWith("/admin");
  const isMaintenance = loc.pathname === "/maintenance";

  if (paused && !isAdminPath && !isMaintenance) {
    return <Navigate to="/maintenance" replace />;
  }
  if (!paused && isMaintenance) {
    return <Navigate to="/" replace />;
  }
  return children;
}
